import React, { useState, useEffect } from "react";
import Layout from "../core/Layout";
import { useListSettings, useUpdateSetting } from "./api/setting";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import showToast from "../utils/toast";

const styles = {

 container: {
    width: "80%",
    maxWidth: "800px",
    margin: "30px auto",
    backgroundColor: "#f9f9f9",
    border: "1px solid #ddd",
    borderRadius: "15px",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    paddingBottom: "20px",
  },

  heading: {
	textAlign: "center",
    background: "linear-gradient(135deg, rgb(102, 126, 234), rgb(118, 75, 162))",
    color: "white",
    fontSize: "24px",
    fontWeight: "600",
    padding: "20px 30px",
    borderRadius: "15px 15px 0 0",
    marginBottom: "10px",
  },

  addNoteSection: {
    padding: "0 30px",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },

  input: {
    padding: "10px 12px",
    fontSize: "16px",
    borderRadius: "8px",
    border: "1px solid #ccc",
  },

  textarea: {
    padding: "10px 12px",
    fontSize: "16px",
    borderRadius: "8px",
    border: "1px solid #ccc",
    resize: "vertical",
    minHeight: "100px",
  },

  button: {
    alignSelf: "flex-start",
    padding: "10px 16px",
    fontSize: "14px",
    backgroundColor: "#3b82f6",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
	marginBottom:"20px"
  },

  buttonSecondary: {
    backgroundColor: "#6b7280", // gray
    marginLeft: "10px",
  },

  buttonDanger: {
    backgroundColor: "#ef4444", // red
    marginLeft: "10px",
  },

  list: {
    listStyle: "none",
    padding: "20px 30px",
    margin: 0,
  },

  listItem: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    padding: "10px 0",
    borderBottom: "1px solid #ddd",
  },

  noteDetails: {
    flex: 1,
    marginRight: "20px",
  },

  noteTitle: {
    fontWeight: "bold",
    fontSize: "16px",
    marginBottom: "5px",
	
  },

  editingInput: {
    display: "block",
    width: "100%",
    marginBottom: "10px",
    padding: "10px",
    fontSize: "16px",
    borderRadius: "8px",
    border: "1px solid #ccc",
  },
};

const AddClinicalNotes = () => {
	const [notes, setNotes] = useState([]);
	const [newNote, setNewNote] = useState({ title: "", description: "" });
	const [editingIndex, setEditingIndex] = useState(null);
	const [editingNote, setEditingNote] = useState({
		title: "",
		description: "",
	});
    
	const navigate = useNavigate();
	const updateSettingMutation = useUpdateSetting();


	const addNote = () => {
		if (newNote.title.trim()) {
			setNotes([...notes, { ...newNote }]);
			setNewNote({ title: "", description: "" });
		} else {
			showToast("Title is required");
		}
	};

	const deleteNote = (index) => {
		setNotes(notes.filter((_, i) => i !== index));
	};

	const startEditing = (index) => {
		setEditingIndex(index);
		setEditingNote(notes[index]);
	};

	const saveEditing = () => {
		if (editingNote.title.trim()) {
			const updatedNotes = notes.map((note, index) =>
				index === editingIndex ? editingNote : note
			);
			setNotes(updatedNotes);
			setEditingIndex(null);
			setEditingNote({ title: "", description: "" });
		} else {
			showToast("Title is required");
		}
	};

	const userLogin = useSelector((state) => state.userLogin);
	const { userInfo } = userLogin;

	const { data: settings } = useListSettings();

	useEffect(() => {
		if (notes.length > 0) {
			updateSettingMutation.mutate({ category: null, setting: { clinicalNotes: notes } });
		}
	}, [notes]);

	useEffect(() => {
		if (settings?.data.clinicalNotes) {
			setNotes(settings?.data.clinicalNotes);
		}
	}, [settings]);

	useEffect(() => {
		if (!userInfo) {
			navigate("/signin");
		}
	}, [userInfo, navigate]);

	return (
		<Layout title={""}>
		
			<div style={styles.container}>
				<h3 style={styles.heading}>Clinical Notes</h3>

				{/* Add New Note Section */}
				<div style={styles.addNoteSection}>
					<input
						style={styles.input}
						type="text"
						placeholder="Title"
						value={newNote.title}
						onChange={(e) =>
							setNewNote({ ...newNote, title: e.target.value })
						}
					/>
					<textarea
						style={styles.textarea}
						placeholder="Description"
						value={newNote.description}
						onChange={(e) =>
							setNewNote({
								...newNote,
								description: e.target.value,
							})
						}
					/>
					<button style={styles.button} onClick={addNote}>
						Add Note
					</button>
				</div>

				{/* Notes List */}
				{notes.length === 0 ? (
					<p style={{color:"black"}}>No clinical notes added yet.</p>
				) : (
					<ul style={styles.list}>
						{notes.map((note, index) => (
							<li key={index} style={styles.listItem}>
								{editingIndex === index ? (
									<div style={{ flex: 1 }}>
										<input
											style={styles.editingInput}
											type="text"
											value={editingNote.title}
											placeholder="Title"
											onChange={(e) =>
												setEditingNote({
													...editingNote,
													title: e.target.value,
												})
											}
										/>
										<textarea
											style={styles.editingInput}
											value={editingNote.description}
											placeholder="Description"
											onChange={(e) =>
												setEditingNote({
													...editingNote,
													description: e.target.value,
												})
											}
										/>
										<div>
											<button
												style={styles.button}
												onClick={saveEditing}>
												Save
											</button>
											<button
												style={{
													...styles.button,
													...styles.buttonSecondary,
												}}
												onClick={() =>
													setEditingIndex(null)
												}>
												Cancel
											</button>
										</div>
									</div>
								) : (
									<>
										<div style={styles.noteDetails}>
											<div style={styles.noteTitle}>
												{note.title}
											</div>
											<div>{note.description}</div>
										</div>
										<div>
											<button
												style={styles.button}
												onClick={() =>
													startEditing(index)
												}>
												Edit
											</button>
											<button
												style={{
													...styles.button,
													...styles.buttonDanger,
												}}
												onClick={() =>
													deleteNote(index)
												}>
												Delete
											</button>
										</div>
									</>
								)}
							</li>
						))}
					</ul>
				)}
			</div>
		</Layout>
	);
};

export default AddClinicalNotes;
